export function normalizeHierarchyHref(href: string): string {
  return href.replace(/^\.?\//, '').trim()
}

interface HierarchyLookupKeyOptions {
  includeWithoutFragment?: boolean
}

export function getHierarchyLookupKeys(href: string, options: HierarchyLookupKeyOptions = {}): string[] {
  if (!href) {
    return []
  }

  const { includeWithoutFragment = true } = options

  const normalized = normalizeHierarchyHref(href)
  const keys = [href, normalized]

  const hashIndex = normalized.indexOf('#')
  if (includeWithoutFragment && hashIndex > -1) {
    const withoutFragment = normalized.slice(0, hashIndex)
    if (withoutFragment) {
      keys.push(withoutFragment)
    }
  }

  return Array.from(new Set(keys.filter(Boolean)))
}

export function isExcludedHierarchyHref(href: string, excludedHrefs: Set<string>): boolean {
  const normalized = normalizeHierarchyHref(href)
  const withoutFragment = normalized.split('#')[0] ?? ''

  return excludedHrefs.has(normalized) || excludedHrefs.has(withoutFragment)
}

export function resolvePageNumberFromHierarchyLookup(href: string, pageNumberLookup: Map<string, string>): string | undefined {
  const lookupKeys = getHierarchyLookupKeys(href)

  for (const key of lookupKeys) {
    const pageNumber = pageNumberLookup.get(key)
    if (pageNumber) {
      return pageNumber
    }
  }

  return undefined
}
